import type { IButtonConfig } from '../types';

import { create } from '../create';

// ----------------------------------------------------------------------------

function data(data: IButtonConfig[]): HTMLButtonElement[] {
    const list: HTMLButtonElement[] = [];

    for (const item of data) {
        const button = create(item);
        list.push(button.element);
    }

    return list;
}

// ----------------------------------------------------------------------------

export { data };
